/* eslint-disable @typescript-eslint/no-unused-vars */

import { apiClient } from "@/app/apiClient";
import { User } from "firebase/auth";
import { UserIsAdminResponse } from "@anu-its/cat-grpc-app-pb/js/anu/cat_app/user_pb";

const emptyResponse = {
  superAdmin: false,
  orgRoles: [] as string[],
} as UserIsAdminResponse;

async function UserIsAdmin(user: User): Promise<UserIsAdminResponse> {
  if (!user) {
    return emptyResponse;
  }

  try {
    const idToken = await user.getIdToken();
    const userIsAdminResponse = await apiClient.userIsAdmin(
      {},
      {
        headers: { Authorization: `Bearer ${idToken}` },
      },
    );
    return userIsAdminResponse;
  } catch (err) {
    return emptyResponse;
  }
}

export { UserIsAdmin };
